<h2 mat-dialog-title>Retracement Settings:</h2>

<mat-tab-group animationDuration="0ms">
  <mat-tab label="UPWAVE">
    <app-retracement-settings
      [retracementsType]="retracementTypes.UPWAVE"
      (settingsChange)="levelsChanges($event)"
    ></app-retracement-settings>
  </mat-tab>
  <mat-tab label="DOWNWAVE">
    <app-retracement-settings
    [retracementsType]="retracementTypes.DOWNWAVE"
    (settingsChange)="levelsChanges($event)"
    ></app-retracement-settings>
  </mat-tab>
</mat-tab-group>

<div class="pb-3" mat-dialog-actions>
  <button mat-button (click)="onDismiss()">Cancel</button>
  <button mat-raised-button [color]="'glb_greenbtn'" (click)="onConfirm()">
    Apply
  </button>
</div>
